export const variantConfig = {
  primary: 'bg-primary text-on-primary',
  primaryContainer:
    'bg-primary-container border border-primary-container text-primary',
  primaryOutline: 'border border-primary text-primary',
  primaryOutlineActive:
    'text-primary border border-primary bg-surface-container',
  primaryTransparent: 'text-primary',
  info: 'bg-info text-on-info',
  infoContainer: 'bg-info-container text-info',
  infoTransparent: 'text-info',
  infoOutline: 'border border-info text-info',
  success: 'bg-success text-on-success',
  successContainer: 'bg-success-container text-success',
  successTransparent: 'text-success',
  successOutline: 'border border-success text-success',
  warning: 'bg-warning text-on-warning',
  warningContainer: 'bg-warning-container text-warning',
  warningTransparent: 'text-warning',
  warningOutline: 'border border-warning text-warning',
  warningYellow: 'bg-warning-yellow text-on-warning-yellow',
  warningYellowContainer: 'bg-warning-yellow-container text-warning-yellow',
  warningYellowTransparent: 'text-warning-yellow',
  warningYellowOutline: 'border border-warning-yellow text-warning-yellow',
  error: 'bg-error text-on-error',
  errorContainer: 'bg-error-container text-error',
  errorTransparent: 'text-error',
  errorOutline: 'border border-error text-error',
  black: 'bg-on-surface-variant text-surface',
  blackContainer: 'bg-surface-container-high text-on-surface',
  outline: 'text-on-surface-variant border border-outline-variant',
  secondaryContainer: 'bg-secondary-container text-secondary'
}

export const sizeConfig = {
  default: 'py-1 px-2',
  xs: 'pl-1 py-0.5 pr-1.5',
  md: 'pl-2 py-1.5 pr-2.5',
  lg: 'pl-2.5 py-2 pr-3.5',
  xl: 'py-3.5 px-6'
}

export const iconSizeConfig = {
  default: '16px',
  xs: '12px',
  md: '16px',
  lg: '18px',
  xl: '24px'
}
